#!/usr/bin/env node
import { main } from '../cli.ts';
await main('GET');
